import { GET_RENEWAL_CONFRATIO, LEAD_OPEN_DATA, RENEWAL_TRACK_SEARCH, GET_ESCALATION_DATA, SEARCH_FILTER_FORM, UPDATE_STATUS } from '../types/RenewalManageType'

const initState = { renewalConvData: [], leadOpenData: [], esclationData: [], searchResults: [], searchFilterForm: {},statusUpdate:false  }

export const RenewalManageReducer = (state = initState, action) => {

    switch (action.type) {
        case GET_RENEWAL_CONFRATIO:
            return {
                ...state,
                renewalConvData: !action.error ? action.payload.list : state.renewalConvData
            }
        case LEAD_OPEN_DATA:
            return {
                ...state,
                leadOpenData: !action.error ? action.payload.list : state.leadOpenData
            }
        case GET_ESCALATION_DATA:
            return {
                ...state,
                esclationData: !action.error ? action.payload.list : state.esclationData
            }
        case RENEWAL_TRACK_SEARCH:
            return {
                ...state,
                searchResults: !action.error ? action.payload.list : state.searchResults
            }
        case SEARCH_FILTER_FORM:
            return {
                ...state,
                searchFilterForm: action.payload
            }
        case UPDATE_STATUS:
            return {
                ...state,
                statusUpdate: action.payload
            }
        // case  UPDATE_RTM_ESCALLATION:
        //     const index = state.esclationData.findIndex(obj=>obj._id === action.payload.id);
        //     return {
        //         ...state,
        //         esclationData:!action.error ?[...state.esclationData.slice(0, index), action.payload, ...state.esclationData.slice(index + 1)]:state.esclationData
        //     }   
        // case UPDATE_LEAD_OPEN:
        //     const index2 = state.leadOpenData.findIndex(obj=>obj._id === action.payload.id);
        //     return {
        //         ...state,
        //         leadOpenData:!action.error ?[...state.leadOpenData.slice(0, index2), action.payload, ...state.leadOpenData.slice(index2 + 1)]:state.leadOpenData
        //     }
        default:
            return state;
    }
}